export default "__VITE_ASSET__BpECYgb9__"